import { ExamType } from 'interfaces/ExamType'

export const getSelectableExamTypes = (examTypes: ExamType[]) => examTypes.filter((exam) => exam.name !== 'DEFAULT')
